import { Locale, type LocalizedString } from "../Locale.js";
import { SubscriptionVariant } from "../SubscriptionVariant.js";

export const subscriptionVariantNameMap: Record<SubscriptionVariant, LocalizedString> = {
	[SubscriptionVariant.Espresso]: { [Locale.cs]: "Espresso", [Locale.en]: "Espresso" },
	[SubscriptionVariant.Filter]: { [Locale.cs]: "Filtr", [Locale.en]: "Filter" },
};
